var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "1200px",
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.$t("CargoMsg.LCLList")
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.xhqMultCustom
        ? _c(
            "div",
            { staticStyle: { color: "red", "margin-bottom": "10px" } },
            [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.MultipleCustomsDeclarationInaccurate"))
              )
            ]
          )
        : _vm._e(),
      _c("div", { staticStyle: { width: "100%" } }, [
        _c("div", { staticStyle: { float: "left", width: "30%" } }, [
          _c("div", { staticStyle: { height: "30px" } }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.IsTheLCLListSent")) +
                  "：" +
                  _vm._s(
                    _vm.selectedContainer.xhqTaskId
                      ? _vm.$t("CargoMsg.Cargo_Sent")
                      : _vm.$t("CargoMsg.Cargo_NotSent")
                  )
              )
            ])
          ]),
          _c("div", { staticStyle: { height: "30px" } }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.ContainerNo")) +
                  "：" +
                  _vm._s(_vm.selectedContainer.containerNo)
              )
            ]),
            _c("label", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v(
                _vm._s(_vm.$t("CargoMsg.Cargo_ContainerSize")) +
                  "：" +
                  _vm._s(
                    _vm.selectedContainer.eqSize + _vm.selectedContainer.eqType
                  )
              )
            ])
          ]),
          _c("div", { staticStyle: { height: "30px" } }, [
            _c("label", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("CargoMsg.Cargo_VesselAndVoyage")) +
                  "：" +
                  _vm._s(_vm.job.vessel + "/" + _vm.job.voyageFlight) +
                  " "
              )
            ])
          ])
        ]),
        _c("div", { staticStyle: { float: "left", width: "40%" } }, [
          _c(
            "div",
            { staticStyle: { height: "40px" } },
            [
              _c("label", [
                _vm._v(" " + _vm._s(_vm.$t("CargoMsg.iEPort")) + " ")
              ]),
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.iEPort,
                    callback: function($$v) {
                      _vm.iEPort = $$v
                    },
                    expression: "iEPort"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label:
                        _vm.xhqIEPortConstants.FOREIGN_PORT_CUSTOMS.chineseName,
                      value:
                        _vm.xhqIEPortConstants.FOREIGN_PORT_CUSTOMS.chineseName
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label:
                        _vm.xhqIEPortConstants.YANG_SHAN_PORT_AREA.chineseName,
                      value:
                        _vm.xhqIEPortConstants.YANG_SHAN_PORT_AREA.chineseName
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.xhqIEPortConstants.WU_SONG.chineseName,
                      value: _vm.xhqIEPortConstants.WU_SONG.chineseName
                    }
                  })
                ],
                1
              ),
              _c("span", { staticStyle: { "margin-left": "10px" } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "CargoMsg.ItIsRecommendedToFillInWhenTheExitPortIsShanghai"
                    )
                  )
                )
              ])
            ],
            1
          ),
          _c("div", { staticStyle: { height: "30px" } }, [
            _c("label", [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.TotalNumberOfPackages")) +
                  "：" +
                  _vm._s(_vm.totalQuantity)
              )
            ]),
            _c("label", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.TotalWeight")) +
                  "：" +
                  _vm._s(_vm.totalWeight)
              )
            ]),
            _c("label", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.TotalCubage")) +
                  "：" +
                  _vm._s(_vm.totalCubage)
              )
            ])
          ])
        ])
      ]),
      _c("cargo-ag-grid", {
        staticStyle: { "min-width": "160px", width: "100%", height: "600px" },
        attrs: {
          "show-side-bar": false,
          "grid-options": _vm.gridOptions,
          "row-data": _vm.lclList,
          "column-defs": _vm.columnDefs
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.xhqMultCustom },
              on: { click: _vm.toXhqSendLCLList }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Send")))]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.$t("Message.Cancel2")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }